import { defineComponent } from "vue";

/**
 * 渲染 `Notice` SVG 图标。
 *
 * @remarks
 * Vue 透传属性（如 `class`、`style`、`role`、`aria-label`、`width`、`height` 和 `fill`）会应用到根 `<svg>` 元素。
 */
export const Notice = defineComponent({
	name: "Notice",
	render() {
		return (
			<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 1024 1024">
				<path d="M627.2 147.5c-18-11.25-40.05-13.05-62.1-2.7l-283.5 166.05H142.1c-32.4 0-58.95 26.55-58.95 58.95v299.25c0 32.4 26.55 58.95 58.95 58.95h139.5l285.75 167.4c8.1 4.05 17.1 5.85 26.1 5.85 11.7 0 23.4-3.15 33.3-9.9 18-11.25 28.8-31.05 28.8-52.2v-639c0-21.6-10.8-41.4-28.35-52.65zM260 668.15l-117 0.9-0.9-297.9H260v297z m335.25 173.7L319.85 680.3V358.1l274.5-160.65 1.35 641.7-0.45 2.7z m342-331.65c0 16.65-13.5 30.15-30.15 30.15H770.3a30.15 30.15 0 0 1 0-60.3h136.8c16.65 0 30.15 13.5 30.15 30.15z m-192.15-153c-9-13.95-5.4-32.4 8.1-41.4L872 236.6c13.95-9.45 32.4-5.4 41.4 8.1 9 13.95 5.4 32.4-8.1 41.4L786.5 365.3c-4.95 3.6-10.8 4.95-16.65 4.95-9.45 0.45-18.9-4.05-24.75-13.05z m160.2 376.65c13.95 9 17.55 27.9 8.1 41.4-5.85 8.55-15.3 13.5-25.2 13.5-5.85 0-11.7-1.8-16.65-4.95L752.75 704.6c-13.95-9-17.55-27.9-8.1-41.4 9-13.95 27.9-17.55 41.4-8.1l119.25 78.75z" />
			</svg>
		);
	},
});

export default Notice;
